import React, { FunctionComponent } from 'react';

export type GovernmentChargeItemProps = {
  id: string;
  heading: string;
  monthCost: string;
  yearCost: string;
};
export const GovernmentChargeItem: FunctionComponent<GovernmentChargeItemProps> = ({
  id,
  heading,
  monthCost,
  yearCost,
}) => (
  <tr>
    <th id={id} scope="row">
      {heading}
    </th>
    <td headers={`${id} annual`}>{yearCost}</td>
    <td headers={`${id} monthly`}>{monthCost}</td>
  </tr>
);

export default GovernmentChargeItem;
